import { useContext } from "react";

import { separateLineItems } from "../../context/cartHelpers";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import LineItem from "./LineItem";
import { ComponentType } from "../../constants/ComponentType";
import { CartContext } from "../../context/CartProvider";
import { HandleType } from "../../constants/HandleType";

function SideCartItems({ lineItems, toggleCart, freegiftLineItemId, isLuxe, onSwapGift }) {
  const { removeSingleProductsFromCart } = useContext(CartContext);

  const { regularItems } = separateLineItems(lineItems);

  const lineItemsbyContainers = [
    ...regularItems.map((item) => ({ componentType: ComponentType.LINE_ITEM, lineItems: [item] })),
  ].sort(
    ({ lineItems: itemsA }, { lineItems: itemsB }) =>
      lineItems.findIndex((item) => item.id === itemsA[0].id) -
      lineItems.findIndex((item) => item.id === itemsB[0].id)
  );

  const removeItem = (lineItemId, lineItem) => {
    removeSingleProductsFromCart({ lineToRemove: lineItem });
  };

  return (
    <div>
      {lineItemsbyContainers.map(({ componentType, lineItems }) => {
        if (componentType === ComponentType.LINE_ITEM) {
          const lineItem = lineItems[0];

          if (
            lineItem?.variant?.product?.handle === HandleType.ORDER_PROTECTION ||
            lineItem?.variant?.product?.handle === HandleType.SUBSCRIPTION
          )
            return null;
          return (
            <div key={`side-cart-item--${lineItem.id}`} className="sidecart-item">
              <LineItem
                key={lineItem.id}
                lineItem={lineItem}
                toggleCart={toggleCart}
                onRemove={(lineItemId) => removeItem(lineItemId, lineItem)}
                isFreeGift={freegiftLineItemId && freegiftLineItemId === lineItem?.id}
                isLuxe={isLuxe}
                onSwapGift={onSwapGift}
              />
            </div>
          );
        }
      })}
    </div>
  );
}

export default withALErrorBoundary({
  name: "SideCartItems",
  priority: "P1",
})(SideCartItems);
